import { Question } from "#models/job-templates/section";
import { Tag } from "#models/utilities/tag.model";
import { VariableTag } from "./variable.model";

export class LogicQuestion {
  ID: string;
  Name: string;
  Output: boolean;
  Conditions: Array<Condition>;
  VariableTags: Array<VariableTag>;
}

export class Condition {
  LogicVariableID: string;
  QuestionID: string;
  SelectedAnswer: string;
  ID: string;
  Disabled: boolean;
  Question: Question;
}

export class SmartActivityId {
  Type: string;
  Designation: string;
  TurnAroundPhase: string;
  ID: string;
  StartNumber: number;
  EndNumber: number;
}
